// Keep existing image dimensions, lazy loading, and theme request behavior intact.
const watched = new WeakSet();
const visible = new Set();
const pending = new Set();
const requests = new Set();
const badge = document.createElement('div');
badge.className = 'rumiloo-content-loading';
badge.setAttribute('role', 'status');
badge.setAttribute('aria-live', 'polite');
badge.textContent = 'Loading…';
badge.hidden = true;
document.body.append(badge);
let reveal;

function refresh() {
  const busy = requests.size > 0 || [...pending].some(el => visible.has(el) && el.isConnected);
  if (!busy) {
    clearTimeout(reveal);
    reveal = null;
    badge.hidden = true;
  } else if (badge.hidden && !reveal) {
    reveal = setTimeout(() => { badge.hidden = false; reveal = null; }, 180);
  }
}

function settle(el) {
  pending.delete(el);
  el.classList.remove('rumiloo-image-loading');
  refresh();
}

function track(el) {
  if (el instanceof HTMLImageElement) {
    const lazy = el.classList.contains('lazyload') || el.classList.contains('lazyloading');
    if (!lazy && el.complete) return settle(el);
    el.classList.add('rumiloo-image-loading');
  } else if (el.readyState >= 3 || el.error || el.networkState === 0 || (el.preload === 'none' && el.paused)) return settle(el);
  pending.add(el);
  refresh();
}

const observer = new IntersectionObserver(entries => {
  for (const entry of entries) {
    if (entry.isIntersecting) visible.add(entry.target);
    else visible.delete(entry.target);
  }
  refresh();
});

function initialize(scope) {
  const media = [...scope.querySelectorAll('img, video:not([data-deferred-video])')];
  if (scope.matches?.('img, video:not([data-deferred-video])')) media.push(scope);
  for (const el of media) {
    if (watched.has(el)) continue;
    watched.add(el);
    observer.observe(el);
    el.addEventListener('load', () => track(el));
    el.addEventListener('lazyloaded', () => settle(el));
    el.addEventListener('error', () => settle(el));
    el.addEventListener('canplay', () => settle(el));
    el.addEventListener('playing', () => settle(el));
    el.addEventListener('waiting', () => track(el));
    el.addEventListener('loadstart', () => track(el));
    track(el);
  }
}
initialize(document);
new MutationObserver(records => {
  for (const record of records) {
    if (record.type === 'attributes') {
      if (watched.has(record.target)) track(record.target);
      continue;
    }
    for (const node of record.addedNodes) if (node.nodeType === 1) initialize(node);
    for (const node of record.removedNodes) {
      if (node.nodeType !== 1 || node.isConnected) continue;
      for (const el of [node, ...node.querySelectorAll('img, video')]) {
        observer.unobserve(el);
        pending.delete(el);
        visible.delete(el);
        watched.delete(el);
      }
    }
  }
  refresh();
}).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset'] });

// Theme product tabs, quick view, collection filters, search, and cart use jQuery.
window.rumilooLoadText = async function(url) {
  const request = {};
  requests.add(request);
  refresh();
  try {
    const response = await fetch(url);
    return await response.text();
  } finally {
    requests.delete(request);
    refresh();
  }
};

if (window.jQuery) {
  jQuery(document).on('ajaxSend.rumilooLoading', (_event, xhr, settings) => {
    const url = new URL(settings.url, location.href);
    if (url.origin !== location.origin) return;
    requests.add(xhr);
    refresh();
  }).on('ajaxComplete.rumilooLoading', (_event, xhr) => {
    requests.delete(xhr);
    refresh();
  });
}
